// OpacitySlider.js - Replace with this code
import React, { useState, useEffect } from 'react';
import SliderModal from './sliderModal';
import { useTranslation } from "react-i18next";

const OpacitySlider = () => {
  const [showSlider, setShowSlider] = useState(false);
  const [opacity, setOpacity] = useState(1);
  const { t } = useTranslation();

  const toggleSlider = () => {
    setShowSlider(!showSlider);
  };

  const handleOpacityChange = (event) => {
    setOpacity(event.target.value);
  };

  const closeModal = () => {
    setShowSlider(false);
  };

  useEffect(() => {
    const storedOpacity = localStorage.getItem('opacity');
    if (storedOpacity) {
      setOpacity(Number(storedOpacity));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('opacity', opacity);
  }, [opacity]);

  return (
    <>
      <button
        className="w-full flex items-center gap-3 px-4 py-2 rounded-md hover:bg-green-50 text-gray-700 hover:text-green-600 transition-colors duration-200"
        onClick={toggleSlider}
      >
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          fill="none" 
          viewBox="0 0 24 24" 
          strokeWidth="1.5" 
          stroke="currentColor" 
          className="w-5 h-5"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 5.25h16.5M3.75 12h16.5M3.75 18.75h16.5" />
        </svg>
        <span className="flex-1 text-left">{t("Opacity")}</span>
      </button>
      
      <SliderModal
        showSlider={showSlider}
        opacity={opacity}
        handleOpacityChange={handleOpacityChange}
        closeModal={closeModal}
      />
    </>
  );
};

export default OpacitySlider;